module.exports = __webpack_public_path__ + "static/img/macOS_FAQ_pic10.fb87a27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/macOS_FAQ/macOS_FAQ_pic10.png
// module id = 509
// module chunks = 1